export default "__VITE_ASSET__3c73d2b6__"